if ('serviceWorker' in navigator) {
    const CLAIM_TIMEOUT_MS = 3000
    const RECOVERY_ATTEMPTS_KEY = 'cpm:navigation-recovery-attempts'

    try {
        sessionStorage.removeItem(RECOVERY_ATTEMPTS_KEY)
    } catch {
        // Storage can be disabled independently of service workers.
    }

    navigator.serviceWorker.addEventListener('message', event => {
        if (event.data?.type !== 'CPM_NAVIGATION_RECOVERY') return

        const stage = String(event.data.stage || 'unknown')
        if (stage === 'retrying' || stage === 'resetting-session') return

        window.$sentry?.captureMessage('CPM navigation recovery', {
            level: stage === 'showing-recovery-page' ? 'error' : 'warning',
            tags: { stage },
        })
    })

    const claimIfUncontrolled = registration => {
        if (navigator.serviceWorker.controller) return Promise.resolve()
        if (!registration.active) return Promise.resolve()

        return new Promise(resolve => {
            const timeoutId = setTimeout(resolve, CLAIM_TIMEOUT_MS)

            navigator.serviceWorker.addEventListener('controllerchange', () => {
                clearTimeout(timeoutId)
                resolve()
            }, { once: true })

            registration.active.postMessage({ type: 'CLAIM_CLIENTS' })
        })
    }

    const register = () => {
        navigator.serviceWorker
            .register('/service-worker.js', { scope: '/', updateViaCache: 'none' })
            .then(registration => {
                registration.update().catch(() => {})

                setInterval(() => registration.update().catch(() => {}), 60 * 60 * 1000)

                claimIfUncontrolled(registration).then(() => {
                    console.log(`Service Worker Registration: ${registration?.active?.state}`)
                })
            })
            .catch(error => {
                window.$sentry?.captureException(error, { extra: { context: 'service-worker registration' } })
                console.error(`Registration failed with error: ${error}`)
            })
    }

    if (document.readyState === 'complete') {
        register()
    } else {
        window.addEventListener('load', register, { once: true })
    }
}
